import {
  CircularProgress,
  Grid,
  IconButton,
  TextareaAutosize,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import {
  getDefaultMessages,
  resetDefaultMessages,
  updateDefaultMessages,
} from "../../../repositories/portal_api/ConectaZap";
import { GlobalContext } from "../../../contexts/GlobalContext";
import { ReactComponent as EditIcon } from "../../../assets/icons/edit.svg";
import { ButtonCancel, ButtonSave } from "../../../components/modal/Modal";
import { notify } from "../../../utils/notify";
import { ConectaZapContext } from "../context/ConectaZapContext";
import { Restore } from "@material-ui/icons";

const TabDefaultMessages = () => {
  const [messages, setMessages] = useState([]);

  const [loading, setLoading] = useState(true);

  const [indexEditing, setIndexEditing] = useState(null);

  const [messageEditing, setMessageEditing] = useState("");

  const { companyUser } = useContext(GlobalContext);

  const { setLoadingPage } = useContext(ConectaZapContext);

  useEffect(() => {
    const initialSetup = async () => {
      try {
        const response = await getDefaultMessages(companyUser.document);
        setMessages(response?.data);
      } catch (e) {
        setMessages([]);
        notify("Erro ao buscar mensagens padrão", true, "error");
      } finally {
        setLoading(false);
      }
    };

    initialSetup().then(() => {
      setLoading(false);
    });

    // eslint-disable-next-line
  }, []);

  const openEditMessage = (index) => {
    setIndexEditing(index);
    setMessageEditing(messages[index].message);
  };

  const saveEditingMessage = async () => {
    setLoadingPage(true);
    try {
      const response = await updateDefaultMessages(
        companyUser.document,
        messages[indexEditing]?.key,
        messageEditing
      );

      if (response.success) {
        notify("Mensagem atualizada com sucesso", true, "success");

        setMessages(
          messages.map((m, index) =>
            index === indexEditing ? { ...m, message: messageEditing } : m
          )
        );
      }

      setIndexEditing(null);
      setMessageEditing("");
    } catch (e) {
      notify("Erro ao atualizar mensagem", true, "error");
    } finally {
      setLoadingPage(false);
    }
  };

  const cancelEditingMessage = () => {
    setIndexEditing(null);
    setMessageEditing("");
  };

  const resetMessage = async () => {
    setLoadingPage(true);

    try {
      const response = await resetDefaultMessages(
        companyUser.document,
        messages[indexEditing]?.key
      );

      if (response.success) {
        notify("Mensagem restaurada com sucesso", true, "success");

        try {
          const responseMessages = await getDefaultMessages(
            companyUser.document
          );
          setMessages(responseMessages?.data);
        } catch (e) {
          setMessages([]);
          notify("Erro ao buscar mensagens padrão", true, "error");
        }

        setIndexEditing(null);
        setMessageEditing("");
      }
    } catch (e) {
      notify("Erro ao restaurar mensagem", true, "error");
    } finally {
      setLoadingPage(false);
    }
  };
  return (
    <>
      <Grid
        container
        spacing={2}
        style={{
          borderRadius: 15,
        }}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              marginTop: 24,
              marginBottom: 16,
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#364461",
                  marginTop: 16,
                  marginBottom: 16,
                }}
              >
                Configure as mensagens padrão enviadas a seus clientes pelo
                sistema
              </Typography>
            </Grid>

            {messages.map((message, index) => (
              <Grid item xs={12} sm={6} style={{}}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    border: "1px solid #E0E0E0",
                    borderRadius: 15,
                    padding: 16,
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      fontSize: 14,
                      fontWeight: 500,
                      marginBottom: 8,
                      textOverflow: "ellipsis",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Tooltip
                        title={
                          <>
                            <div>{message?.description}</div>

                            {message?.variables?.length > 0 && (
                              <div>
                                <br />
                                <span>Variáveis:</span>
                                <br />
                                {message?.variables?.map((variable) => (
                                  <span key={variable.name}>
                                    %{variable.name}% - {variable.description}
                                  </span>
                                ))}
                              </div>
                            )}
                          </>
                        }
                      >
                        <div>{message?.nameExibition}</div>
                      </Tooltip>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row" }}>
                      {index !== indexEditing && (
                        <div>
                          <IconButton
                            size="small"
                            onClick={() => {
                              openEditMessage(index);
                            }}
                          >
                            <EditIcon color="#616161" height={16} width={16} />
                          </IconButton>
                        </div>
                      )}
                    </div>
                  </div>
                  {index === indexEditing ? (
                    <>
                      <TextareaAutosize
                        fullWidth
                        minRows={4}
                        variant="outlined"
                        size="small"
                        style={{
                          maxWidth: "100%",
                          width: "100%",
                          minWidth: "100%",
                          borderRadius: "8px",
                          padding: "8px",
                        }}
                        placeholder="CPF/CNPJ"
                        value={messageEditing}
                        onChange={(e) => {
                          setMessageEditing(e.target.value);
                        }}
                        type="textarea"
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          marginTop: 8,
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <Tooltip title="Restaurar mensagem padrão">
                            <IconButton
                              size="small"
                              onClick={async () => await resetMessage()}
                            >
                              <Restore color="#616161" height={16} width={16} />
                            </IconButton>
                          </Tooltip>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 8,
                          }}
                        >
                          <ButtonCancel
                            onClick={cancelEditingMessage}
                            style={{ height: 32 }}
                          >
                            Cancelar
                          </ButtonCancel>
                          <ButtonSave
                            onClick={async () => await saveEditingMessage()}
                            style={{ height: 32 }}
                          >
                            Salvar
                          </ButtonSave>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div>{message?.message}</div>
                  )}
                </div>
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </>
  );
};

export default TabDefaultMessages;
